import { georesourceConstants } from '../constants';

export function georesource(state = {}, action) {
  switch (action.type) {
    case georesourceConstants.GET_CITIES_REQUEST:
      return {
        loading: true
      };
    case georesourceConstants.GET_CITIES_SUCCESS:
      return {
        ...state, cities: action.data
      }
    case georesourceConstants.GET_CITIES_FAILURE:
      return {
        error: action.error
      };
    case georesourceConstants.GET_COUNTRIES_REQUEST:
      return {
        loading: true
      };
    case georesourceConstants.GET_COUNTRIES_SUCCESS:
      return {
        ...state, countries: action.data
      }
    case georesourceConstants.GET_COUNTRIES_FAILURE:
      return {
        error: action.error
      };
    case georesourceConstants.GET_CURRENCIES_REQUEST:
      return {
        loading: true
      };
    case georesourceConstants.GET_CURRENCIES_SUCCESS:
      return {
        ...state, currencies: action.data
      }
    case georesourceConstants.GET_CURRENCIES_FAILURE:
      return {
        error: action.error
      };
    case georesourceConstants.GET_COUNTRIES_DIAL_CODES_REQUEST:
      return {
        loading: true
      };
    case georesourceConstants.GET_COUNTRIES_DIAL_CODES_SUCCESS:
      return {
        ...state, dialcodes: action.data
      }
    case georesourceConstants.GET_COUNTRIES_DIAL_CODES_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
